module.exports = __webpack_public_path__ + "img/consultant01.ead6f59b.jpg";